import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

interface service {
    name: string,
    api: string,
}

interface route {
    name: string,
    params?: {[k: string]: any},
    query?: {[k: string]: any}
}

@Component
/**
 * ProfileOrders Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Title of the Panel
     */
    @Prop() title!: string;

    /**
     * Orders List Link
     */
    @Prop({ default: () => ({ name: 'dashboard-orders' }) }) ordersListLink!: route;

    /**
     * Order Details Link
     */
    @Prop({ default: 'dashboard-order-details' }) detailsLinkName!: string;

    /**
     * Fetch Orders Service
     */
    @Prop({ default: () => ({ name: 'Cart', api: 'myOrdersList' }) }) fetchOrdersService!: service;

    /**
     * Fetch Orders Service
     */
    @Prop({ default: () => ({ name: 'Cart', api: 'orderDetails' }) }) fetchOrderDetailsService!: service;

    /**
     * Filters
     */
    @Prop({ default: () => (['all', 'open', 'close']) }) filters!: Array<string>;
}
